import React, { useContext } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { appContext } from '../App'
import { functionsContext } from '../CONTEXTS/FunctionsContext'
import UserPfp from './GENERAL-COMPONENTS/UserPfp'
import VerifiedBadge from './GENERAL-COMPONENTS/VerifiedBadge'

const Notification = ({ noti }) => {
  const { users, user } = useContext(appContext)
  const { sentAt, taggedBy, type, postId, commentId, repliedBy, likedBy, replyId, storyId } = noti




  if (type === 'post-tag') {
    const creator = users.find(user => user.id === taggedBy)
    
    if (creator?.id && creator.id !== user.id) {
      return (
        <div className='notification' >
          <NotificationImage creator={creator} />

    
          <Link to={`/posts/${postId}`}>
            <CreatorDisplayName creator={creator} /> mentioned you in a post.
            
            <TimeSincePosted sentAt={sentAt} />
          </Link>
        </div>
      )
    }
    
  } else if (type === 'comment-tag') {
    const creator = users.find(user => user.id === taggedBy)

    if (creator?.id && creator.id !== user.id) {
      return (
        <div className='notification' >
          <NotificationImage creator={creator} />
    
          <Link to={`/posts/${postId}/comments/${commentId}`}>
            <CreatorDisplayName creator={creator} /> mentioned you in a comment.
            
            <TimeSincePosted sentAt={sentAt} />
          </Link>
        </div>
      )
    }

  } else if (type === 'reply-tag') {
    const creator = users.find(user => user.id === taggedBy)

    if (creator?.id && creator.id !== user.id) {
      return (
        <div className='notification'>
          <NotificationImage creator={creator} />
    
          <Link to={`/posts/${postId}/comments/${commentId}/replies/${replyId}`}>
            <CreatorDisplayName creator={creator} /> mentioned you in a reply.
            
            <TimeSincePosted sentAt={sentAt} />
          </Link>
        </div>
      )
    }

  } else if (type === 'post-like') {
    const creator = users.find(user => user.id === likedBy)

    const postLink = postId ? `/posts/${postId}` : ''
    
    if (creator?.id && creator.id !== user.id) {
      return (
        <div className='notification' >
          <NotificationImage creator={creator} />
    
          <Link to={postLink}>
            <CreatorDisplayName creator={creator} /> liked your post.
            
            <TimeSincePosted sentAt={sentAt} />
          </Link>
        </div>
      )
    }
    
  } else if (type === 'comment-like') {
    const creator = users.find(user => user.id === likedBy)

    if (creator?.id && likedBy !== user.id) {
      return (
        <div className='notification' >
          <NotificationImage creator={creator} />
    
          <Link to={`/posts/${postId}/comments/${commentId}`}>
            <CreatorDisplayName creator={creator} /> liked your comment.
            
            <TimeSincePosted sentAt={sentAt} />
          </Link>
        </div>
      )
    }
    
  } else if (type === 'reply-like') {
    const creator = users.find(user => user.id === likedBy)

    if (creator?.id && likedBy !== user.id) {
      return (
        <div className='notification' >
          <NotificationImage creator={creator} />
    
          <Link to={`/posts/${postId}/comments/${commentId}/replies/${replyId}`}>
            <CreatorDisplayName creator={creator} /> liked your reply.
            
            <TimeSincePosted sentAt={sentAt} />
          </Link>
        </div>
      )
   }

  } else if (type === 'post-reply') {
    const creator = users.find(user => user.id === repliedBy)

    if (creator?.id && repliedBy !== user.id) {
      return (
        <div className='notification' >
          <NotificationImage creator={creator} />
    
          <Link to={`/posts/${postId}/comments/${commentId}`}>
            <CreatorDisplayName creator={creator} /> commented on your post.
            
            <TimeSincePosted sentAt={sentAt} />
          </Link>
        </div>
      )
    }

  } else if (type === 'comment-reply' || type === 'reply-reply') {
    const creator = users.find(user => user.id === repliedBy)

    if (creator?.id && repliedBy !== user.id) {
      return (
        <div className='notification' >
          <NotificationImage creator={creator} />
    
          <Link to={`/posts/${postId}/comments/${commentId}/replies/${replyId}`}>
            <CreatorDisplayName creator={creator} />
            {type === 'comment-reply' ?
              'replied your comment.' :

              type === 'reply-reply' ?
              'replied you.' : ''
            }
            <TimeSincePosted sentAt={sentAt} />
          </Link>
        </div>
      )
    }

  } else if (type === 'story-tag') {
    const creator = users.find(user => user.id === taggedBy)

    if (creator?.id && taggedBy !== user.id) {
      const { username } = creator

      const storyLink = `/stories/${username.trim()}/${storyId}?storyBy=following`

      return (
        <div className='notification' >
          <NotificationImage creator={creator} />
    
          <Link
            to={storyLink}
          >
            <CreatorDisplayName creator={creator} /> mentioned you in a story.
            
            <TimeSincePosted sentAt={sentAt} />
          </Link>
        </div>
      )
    }
  }
}

export default Notification




const NotificationImage = ({ creator }) => {

  return (
    <a href={creator?.id && creator.id} className='noti-img-div'>
      <UserPfp user={creator} />
    </a>
  )
}



const CreatorDisplayName = ({ creator }) => {
  return (
    <b>
      {creator?.id && creator.displayName} 
      {creator?.id && creator.userType === 'creator' && <VerifiedBadge />}
    </b>
  )
}



const TimeSincePosted = ({ sentAt }) => {
  const { timeSincePosted } = useContext(functionsContext)
  
  return (
    <span className="noti-sentAt">
      {timeSincePosted(sentAt)}
    </span>
  )
}